module.exports = __webpack_public_path__ + "static/media/main-banner-1.0a144c70.png";